// Utility function to show notifications via Service Worker

export const showNotification = async (
  title: string,
  options: {
    body: string;
    icon?: string;
    tag?: string;
    data?: { url: string };
  },
): Promise<void> => {
  // Request permission if not already granted
  const permission = await Notification.requestPermission();

  if (permission !== 'granted') {
    console.log('Notification permission denied');
    return;
  }

  // Check if service worker is available
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.ready;

      // Show notification via service worker
      await registration.showNotification(title, {
        body: options.body,
        icon: options.icon || '/favicon.ico',
        tag: options.tag,
        data: options.data,
        requireInteraction: false,
      });

      console.log('Notification shown via Service Worker');
    } catch (error) {
      console.error('Error showing notification via Service Worker:', error);

      // Fallback to regular notification if service worker fails
      const notification = new Notification(title, {
        body: options.body,
        icon: options.icon || '/favicon.ico',
        tag: options.tag,
        data: options.data as any,
      });

      // Add onclick handler for fallback (works only when window is open)
      notification.onclick = () => {
        window.focus();
        if (options.data?.url) {
          window.location.href = options.data.url;
        }
        notification.close();
      };
    }
  } else {
    // Service worker not supported, use regular notification
    const notification = new Notification(title, {
      body: options.body,
      icon: options.icon || '/favicon.ico',
      tag: options.tag,
      data: options.data as any,
    });

    notification.onclick = () => {
      window.focus();
      if (options.data?.url) {
        window.location.href = options.data.url;
      }
      notification.close();
    };
  }
};
